import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid, c as clsx } from './p-70e482d1.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconTrashStyle0 = stylesCss;

const BiIconTrash$1 = /*@__PURE__*/ proxyCustomElement(class BiIconTrash extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: 'c19739ea81213a1258aff7cc4c8327554c2ab5d8', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: '331ab4705169e42a236d4d4c1ea9a280d55532f5', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: '4929c7b519c5b0145330bb524a29107ea01a3fcd', "fill-rule": 'evenodd', d: 'M8.72 3.575h8.287v.998h4.095v1.5h-1.497v12.232a3.247 3.247 0 0 1-3.247 3.246h-7.24a3.247 3.247 0 0 1-3.245-3.246V6.073H4.625v-1.5H8.72zM7.373 6.073v12.232c0 .963.782 1.746 1.746 1.746h7.24c.963 0 1.746-.783 1.746-1.746V6.073zm2.359 10.734V8.509h1.5v8.298zm4.698 0V8.509h1.5v8.298z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconTrashStyle0; }
}, [1, "bi-icon-trash", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-trash"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-trash":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconTrash$1);
            }
            break;
    } });
}

const BiIconTrash = BiIconTrash$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconTrash, defineCustomElement };
